module.exports = __webpack_public_path__ + "static/media/news-1~bdJAbHTf.b4e68ad1.jpg";